import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import { useGetReportInfiniteList } from '@/modules/common/queries/reports.ts';
import { SelectPaginate, SelectPaginateOption } from 'ui';
import { RegisterClass } from 'api';

export type ReportOption = SelectPaginateOption<{
  id: number;
  name?: string;
  type: string;
  entity_id?: number;
  classes: RegisterClass[];
}>;

interface ReportsSelectPaginateProps {
  label?: string;
  error?: string;
  value: ReportOption[];
  disabled?: boolean;
  className?: string;
  classNameSelect?: string;
  onChange: (option: ReportOption[]) => void;
}

const ReportsSelectPaginate = ({
  error,
  value,
  disabled,
  onChange,
  className,
  classNameSelect,
  label = 'Reports',
}: ReportsSelectPaginateProps) => {
  const [params] = useSearchParams();
  const registerId = params.get(REGISTER_ID_SEARCH_PARAM_KEY);

  const { fetchNextPage } = useGetReportInfiniteList({
    payload: { page_size: 15 },
    disabled: true,
  });

  const handleAsync = useCallback(
    async (page: number) => {
      const reportsData = await fetchNextPage({ pageParam: page });
      const reports = reportsData?.data?.pages?.at(-1)?.data || [];
      return reports.map(({ filename, type, entity_id, classes, id }) => ({
        label: filename,
        value: {
          id,
          name: filename || '',
          type,
          entity_id,
          classes,
          toString: () => id,
        },
      })) as ReportOption[];
    },
    [fetchNextPage],
  );

  return (
    <SelectPaginate
      isMulti
      className={className}
      classNameSelect={classNameSelect}
      value={value}
      error={error}
      disabled={disabled}
      onAsync={handleAsync}
      label={label}
      onChange={onChange}
      cacheUniqs={[registerId]}
    />
  );
};

export default ReportsSelectPaginate;
